import { useEffect, useRef, useState } from "react";

function TableWithSlider({
  children,
  className = "",
  containerClassName = "",
  showCustomScrollbar = false,
}) {
  const tableScrollRef = useRef(null);
  const sliderScrollRef = useRef(null);
  const sliderInnerRef = useRef(null);
  const syncingRef = useRef(false);
  const [showSlider, setShowSlider] = useState(false);

  useEffect(() => {
    if (!showCustomScrollbar) return undefined;

    const tableNode = tableScrollRef.current;
    const sliderNode = sliderScrollRef.current;
    const sliderInnerNode = sliderInnerRef.current;

    if (!tableNode || !sliderNode || !sliderInnerNode) return undefined;

    const syncMetrics = () => {
      const scrollWidth = tableNode.scrollWidth;
      const clientWidth = tableNode.clientWidth;
      sliderInnerNode.style.width = `${scrollWidth}px`;
      setShowSlider(scrollWidth > clientWidth + 4);
      sliderNode.scrollLeft = tableNode.scrollLeft;
    };

    syncMetrics();

    const resizeObserver = new ResizeObserver(syncMetrics);
    resizeObserver.observe(tableNode);
    const tableElement = tableNode.querySelector("table");
    if (tableElement) resizeObserver.observe(tableElement);

    window.addEventListener("resize", syncMetrics);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", syncMetrics);
    };
  }, [showCustomScrollbar]);

  const handleTableScroll = () => {
    if (!showCustomScrollbar || syncingRef.current) return;

    const tableNode = tableScrollRef.current;
    const sliderNode = sliderScrollRef.current;
    if (!tableNode || !sliderNode) return;

    syncingRef.current = true;
    sliderNode.scrollLeft = tableNode.scrollLeft;
    requestAnimationFrame(() => {
      syncingRef.current = false;
    });
  };

  const handleSliderScroll = () => {
    if (syncingRef.current) return;

    const tableNode = tableScrollRef.current;
    const sliderNode = sliderScrollRef.current;
    if (!tableNode || !sliderNode) return;

    syncingRef.current = true;
    tableNode.scrollLeft = sliderNode.scrollLeft;
    requestAnimationFrame(() => {
      syncingRef.current = false;
    });
  };

  return (
    <div className={className}>
      <div
        ref={tableScrollRef}
        className={`table-scrollbar-hidden overflow-x-auto border border-obsidian-200 bg-white shadow-cream ${
          containerClassName || "rounded-2xl"
        }`}
        onScroll={handleTableScroll}
      >
        {children}
      </div>

      {showCustomScrollbar && showSlider ? (
        <div
          ref={sliderScrollRef}
          className="custom-table-slider mt-1 overflow-x-auto rounded-full border border-obsidian-200 bg-cream-100 px-2 py-1.5 sm:px-3 sm:py-2"
          onScroll={handleSliderScroll}
          aria-label="Table horizontal scroll"
        >
          <div ref={sliderInnerRef} className="h-4 rounded-full bg-[rgb(15_34_58)] sm:h-5" />
        </div>
      ) : null}
    </div>
  );
}

export default TableWithSlider;
